import(/* webpackMode: "eager", webpackExports: ["CookiesPageContent"] */ "/vercel/path0/app/[locale]/(global)/cookies/CookiesPageContent.tsx");
